
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-b3f63c28&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ProductTrackingSettings.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ProductTrackingSettings.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-b3f63c28!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ProductTrackingSettings.vue"),
  /* scopeId */
  "data-v-b3f63c28",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/settings/ProductTrackingSettings.vue
// module id = 306
// module chunks = 2